import React, { FC, useState } from 'react'

import { StandardButton } from 'src/components/atoms'
import { DeleteCommonContentPageModal } from 'src/components/organisms'

import { useAuthority } from 'src/hooks'
import { CommonContentPageEntity } from 'src/types'

type Props = {
  commonContent: CommonContentPageEntity
  className?: string
}

export const DeleteCommonContentPage: FC<Props> = ({ commonContent, className }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const { canDeleteCommonContent } = useAuthority()

  return (
    <div className={className}>
      {canDeleteCommonContent && (
        <StandardButton
          buttonType="danger"
          text="共通コンテンツ削除"
          appendIconPath="trash/soft/line"
          onClick={() => setShowDeleteModal(true)}
        />
      )}

      <DeleteCommonContentPageModal
        commonContent={commonContent}
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
      />
    </div>
  )
}
